import React from 'react';
import { useAuth } from '../context/AuthContext';
import Login from './Login';

const PrivateRoute = ({ children }) => {
  const { isLoggedIn, isLoading } = useAuth();

  // Mostrar loading mientras se verifica la autenticación
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-600 via-pink-500 to-indigo-600 flex items-center justify-center">
        <div className="bg-white rounded-2xl shadow-2xl p-8 backdrop-blur-sm bg-opacity-95">
          <div className="text-center">
            <div className="text-6xl mb-4">💰</div>
            <h1 className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-4">
              Saver
            </h1>
            <div className="flex items-center justify-center space-x-2">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
              <span className="text-gray-600">Verificando autenticación...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Si no está autenticado, mostrar página de login
  if (!isLoggedIn) {
    return <Login />;
  }

  // Si está autenticado, mostrar el contenido protegido
  return children;
};

export default PrivateRoute; 